<!--<span class="d-flex justify-content-between">
      {{ campaign.name }}
	  <span class="pl-2">
		<span class="badge badge-success">
			<i class="fa fa-phone fa-sm pr-1"></i>{{ campaign.callsMade }} made /  {{ campaign.callsAvailable }} avail.
		</span>
	</span>
</span>-->

<div class="table-responsive">
   <table
      class="table custom-table contact-table"
      style="margin-bottom: 0px">
      <tr>
         <td
            class="d-flex justify-content-between campT"
            style="width: 48%; max-width: 48%; padding-left: 18px; text-align: left">
            <span
               style="font-weight: 600; font-size: 15px; padding-right: 15px"
               class="campTTitle">
               {{ campaign.name }}
            </span>
            <div style="height: 1px; margin-top: 0px"></div>
            <span
               style="font-size: 12px; color: #7a7c7f; font-weight: 500"
               class="campTPhone">
               <i
                  class="fa fa-phone"
                  style="
                     vertical-align: text-top;
                     font-size: 7px;
                     text-align: center;
                     background: #c9cacd;
                     border-radius: 100%;
                     line-height: 16px;
                     width: 16px;
                     height: 16px;
                     color: #ffffff;
                  "></i>
               &nbsp;
               <span style="color: #000000">{{ campaign.callsMade }}</span>
               total text/calls made,
               <span style="color: #000000">{{ campaign.callsAvailable }}</span>
               pending text/calls
            </span>
         </td>
         <td
            class="d-flex justify-content-between campT cm"
            style="width: 16%; max-width: 16%; text-align: right; padding-right: 10px">
            {{ campaign.callsMade }}
         </td>
         <td
            class="d-flex justify-content-between campT ct"
            style="width: 17%; max-width: 17%; text-align: right; padding-right: 10px">
            {{ campaign.callsMadeToday }}
         </td>
         <td
            class="d-flex justify-content-between campT ca"
            style="width: 19%; max-width: 19%; text-align: right; padding-right: 17px; color: #00a876">
            {{ campaign.callsAvailable }}
         </td>
      </tr>
   </table>
</div>
